<!-- Young -->
<template>
  <a-modal
    v-model="isShow"
    title="故障监测"
    width="342px"
    class="public-status"
    centered
    :closable="false"
  >
    <div class="header-title-wrap">
      <div>部件</div>
      <div style="width: 50px;text-align: right;">状态</div>
    </div>
    <div class="content-wrap">
      <div class="status-item-wrap">
        <div class="item-left" title="">主程序是否在前台</div>
        <div class="item-right">正常</div>
      </div>
      <div class="status-item-wrap">
        <div class="item-left" title="">摄像头</div>
        <div class="item-right">正常</div>
      </div>
    </div>
    <template slot="footer">
      <a-button
        key="back"
        type="primary"
        @click="downLoadRecord"
        :disabled="downLoaddisabled"
        class="footer-btn"
        >下载日志</a-button
      >
      <!-- <a ref="downa" :href="downurl" :download="downurl" v-show="false">下载</a> -->
      <a-button
        key="submit"
        @click="isShow = false"
        class="footer-btn"
        style="margin-right: 0; background: #ECEDFF;"
        >取消</a-button
      >
    </template>
  </a-modal>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import accessServices from "@/services/accessControl.services";

export default {
  name: "PublicStatus",
  components: {},
  props: {
    statusData: { required: false }
  },
  data() {
    return {
      downLoaddisabled: true,
      isShow: false,
      downloadID: "",
      downurl: ""
    };
  },
  mounted() {},
  computed: {
    ...mapGetters("uploader", ["downloadList"])
  },
  watch: {
    statusData: {
      immediate: true,
      handler: function(val) {
        if (!val) {
          return;
        }
        if (
          !(
            val.statustype === "门禁设备管理" ||
            val.statustype === "门牌设备管理"
          )
        ) {
          return;
        }
        if (
          val.deviceType === "赤眸5" ||
          val.deviceType === "赤眸6C" ||
          val.deviceType === "赤眸6" ||
          val.deviceType === "赤眸6SE" ||
          val.deviceType === "赤眸6MINI" ||
          val.deviceType === "赤眸5Pro" ||
          val.deviceType === "SpaceKeeper_1"
        ) {
          this.downLoaddisabled = false;
        } else {
          this.downLoaddisabled = true;
        }
      }
    }
  },
  methods: {
    ...mapMutations("uploader", [
      "ADD_URLLIST",
      "ADD_FILE",
      "DELETE_FILE",
      "CHECK_FILE"
    ]),

    // 下载日志---前端判断30s移交后端做失效验证
    async downLoadRecord() {
      // let that = this
      if (!this.statusData) {
        return;
      }
      // 用做请求参数
      let params = {
        eventId: this.getUUid(),
        deviceId: this.statusData.sn
      };
      // 仓库存储用于对比事件
      // let downitem = {
      //   time: new Date(),
      //   deviceId: this.statusData.sn
      // };

      // this.downloadID = params.eventId;
      // 查看下载数组中有没有当前设备
      // let someres = this.downloadList.some(item => {
      //   return item.deviceId === this.statusData.sn;
      // });
      // if (someres) {
      // 当前数组中有当前设备-判断时间：大于30则删除数组元素，发送请求，新增数组元素，小于30则不进行操作
      // let listindex = this.downloadList.findIndex(item => {
      //   return item.deviceId === this.statusData.sn;
      // });
      // let nowdata = (new Date() - this.downloadList[listindex].time) / 1000;

      // if (nowdata >= 30) {
      // 30
      // this.DELETE_FILE(this.statusData.sn);
      const { status, result } = await accessServices.GetLog(params);
      if (status === 0) {
        this.$message.success("日志文件捕获中，请耐心等待......");
        this.ADD_URLLIST({
          time: new Date(),
          eventId: params.eventId
        });
        // this.ADD_FILE(downitem);
        this.isShow = false;
      }
      // } else {
      //   this.$message.warning("勿频繁请求日志数据，请稍后再次点击");
      // }
      // } else {
      //   this.$message.success("日志文件捕获中，请耐心等待......");
      //   const { status, result } = await accessServices.GetLog(params);
      //   if (status == 0) {
      //     this.ADD_URLLIST({
      //       time: new Date(),
      //       eventId: params.eventId
      //     });
      //     this.ADD_FILE(downitem);
      //     this.isShow = false;
      //     //加入仓库
      //   }
      // }
      this.CHECK_FILE();
    },
    // 下载日志-30S间隔
    async downLoadRecord30() {
      let that = this;
      if (!this.statusData) {
        return;
      }
      // 用做请求参数
      let params = {
        eventId: this.getUUid(),
        deviceId: this.statusData.sn
      };
      // 仓库存储用于对比事件
      let downitem = {
        time: new Date(),
        deviceId: this.statusData.sn
      };

      this.downloadID = params.eventId;
      // 查看下载数组中有没有当前设备
      let someres = this.downloadList.some(item => {
        return item.deviceId === this.statusData.sn;
      });
      if (someres) {
        // 当前数组中有当前设备-判断时间：大于30则删除数组元素，发送请求，新增数组元素，小于30则不进行操作
        let listindex = this.downloadList.findIndex(item => {
          return item.deviceId === this.statusData.sn;
        });
        let nowdata = (new Date() - this.downloadList[listindex].time) / 1000;

        if (nowdata >= 30) {
          // 30
          this.$message.success("日志文件捕获中，请耐心等待......");
          this.DELETE_FILE(this.statusData.sn);
          const { status, result } = await accessServices.GetLog(params);
          if (status == 0) {
            this.ADD_URLLIST({
              time: new Date(),
              eventId: params.eventId
            });
            this.ADD_FILE(downitem);
            this.isShow = false;
          }
        } else {
          this.$message.warning("勿频繁请求日志数据，请稍后再次点击");
        }
      } else {
        this.$message.success("日志文件捕获中，请耐心等待......");
        const { status, result } = await accessServices.GetLog(params);
        if (status == 0) {
          this.ADD_URLLIST({
            time: new Date(),
            eventId: params.eventId
          });
          this.ADD_FILE(downitem);
          this.isShow = false;
          // 加入仓库
        }
      }
      this.CHECK_FILE();
    },

    getUUid() {
      let value = "xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        let r = (Math.random() * 16) | 0;
        let v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
      return value;
    }
  }
};
</script>
<style lang="less">
// @import url(); 引入公共css类
.public-status {
  height: 439px;
  .ant-modal-content {
    .ant-modal-header {
      height: 53px;
      padding: 16px 0;
      text-align: center;
    }
    .ant-modal-body {
      height: 320px;
      padding: 0;
    }
    .ant-modal-footer {
      height: 64px;
      padding: 16px;
      text-align: center;
    }
  }
  .header-title-wrap {
    display: flex;
    height: 58px;
    padding: 15px 24px;
    justify-content: space-between;
    border-bottom: 1px solid #f5f5f5;
    font-size: 14px;
    color: #5862cb;
  }
  .footer-btn {
    width: 88px;
    height: 32px;
    margin-right: 32px;
    border-radius: 3px;
    border: 0px;
  }
  .content-wrap::-webkit-scrollbar {
    width: 1px !important;
  }
  .content-wrap {
    height: 262px;
    overflow-y: auto;
    .status-item-wrap {
      height: 50px;
      padding: 15px 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: #333333;
      .item-left {
        flex: 1;
        height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .item-right {
        width: 50px;
        text-align: right;
        margin-left: 24px;
      }
    }
  }
}
</style>
